import { useState } from 'react';
import Page from 'modules/app/components/Page';
import AllServicesHeader from './AllServicesHeader';
import AllServicesFilter from './AllServicesFilter';
import s from './AllServices.module.scss';
import useGetServicesBySalonId from 'sdk/hooks/salon/useGetServicesBySalonId';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Card from '../Services/Card/Card';
import useGetSalonById from 'sdk/hooks/salon/useGetSalonById';
import BackHeader from '../BackHeader';

const AllServices = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: services } = useGetServicesBySalonId(id);
  const { data: salon } = useGetSalonById(id);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const location = useLocation();

  const handleBack = () => {
    const scrollPosition = location.state?.scrollPosition;
    if (typeof scrollPosition === 'number') {
      navigate(`/salon/${id}`, {
        state: {
          tab: 3,
          restoreScroll: true,
          scrollPosition: scrollPosition,
          fromBack: true,
        },
        replace: true,
      });
    } else {
      navigate(`/salon/${id}`);
    }
  };

  const filteredServices = services?.filter(
    service => selectedCategory === 'all' || service.type === selectedCategory,
  );

  console.log(services, 'services');

  return (
    <Page disableOverflow activeLink="/venues">
      <BackHeader title="Services" onBack={handleBack} />
      <div className={s.all_services_container}>
        <AllServicesFilter
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
        <div className={s.all_services_list}>
          <Card data={{ ...salon, services: filteredServices }} />
        </div>
      </div>
    </Page>
  );
};

export default AllServices;
